import { fnDecodeStorageToken } from "./encodeLocalStorage"

export function fnBisAdmin() {
  return fnDecodeStorageToken()?.bAdmin
}

export function fnBIsConsultant() {
  return fnDecodeStorageToken()?.bIsConsultant
}

export function fnUserCtype(cType) {
  return [...cType].includes(fnDecodeStorageToken()?.cTypeUser)
}

export function fnHasModule(cModuleSlug) {
  try {
    if (fnDecodeStorageToken()?.bTrial) {
      return true
    }
    const aModules = fnDecodeStorageToken()?.aModules || []
    return aModules.includes(cModuleSlug)
  } catch (oExcpHasModule) {
    return false
  }
}

export function fnCanAtLeast(varPermissions, cModuleSlug) {
  try {
    let bHasModule = true
    if (typeof cModuleSlug !== "undefined") {
      bHasModule = fnHasModule(cModuleSlug)
    }
    if (!bHasModule) {
      return false
    }

    if (fnBisAdmin()) {
      return true
    }

    const oMyPermissions = fnDecodeStorageToken()?.aPermissions || []
    if (typeof varPermissions === "string") {
      return oMyPermissions.includes(varPermissions)
    }
    return varPermissions.some((elPermission) => oMyPermissions.includes(elPermission))
  } catch (e) {
    return false
  }
}

export function fnCan(varPermissions, cModuleSlug) {
  try {
    let bHasModule = true
    if (typeof cModuleSlug !== "undefined") {
      bHasModule = fnHasModule(cModuleSlug)
    }
    if (!bHasModule) {
      return false
    }

    if (fnBisAdmin()) {
      return true
    }

    const oMyPermissions = fnDecodeStorageToken()?.aPermissions || []
    if (typeof varPermissions === "string") {
      return oMyPermissions.includes(varPermissions)
    }
    return varPermissions.every((elPermission) => oMyPermissions.includes(elPermission))
  } catch (e) {
    return false
  }
}

export function fnIsResponsible(nUserId, oResponsible) {
  if (fnBisAdmin()) return true
  try {
    const isResponsible = oResponsible?.some((r) => r?.user_nid === nUserId)
    if (isResponsible) return true
    if (!isResponsible) return false
  } catch (e) {
    return false
  }
}

export function fnIsObserver(nUserId, aObservers) {
  if (fnBisAdmin()) return false
  try {
    const bIsObserver = aObservers?.some((o) => o?.user_nid === nUserId)
    return bIsObserver
  } catch (e) {
    return false
  }
}
